// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-docs-container {
  padding: 20px;
}
.my-docs-container.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: #666;
  font-size: 16px;
}
.my-docs-container.hierarchy .my-docs-header {
  margin-bottom: 16px;
}
.my-docs-container.hierarchy .my-docs-header .header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.my-docs-container.hierarchy .my-docs-header .header-top h3 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions {
  display: flex;
  gap: 12px;
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn {
  background: #f5f5f5;
  color: #333;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn:hover {
  background: #e5e5e5;
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn.primary {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}
.my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn.primary:hover {
  background: #0052a3;
}
.my-docs-container.hierarchy .my-docs-header .info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
  font-size: 13px;
  color: #666;
}
.my-docs-container.hierarchy .my-docs-header .info-bar .total-items {
  font-weight: 500;
}
.my-docs-container.hierarchy .my-docs-header .info-bar .selected-info {
  color: #0066cc;
  font-weight: 500;
}
.my-docs-container.hierarchy .documents-tree {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
.my-docs-container.hierarchy .documents-tree .no-documents {
  text-align: center;
  padding: 60px 20px;
  color: #666;
}
.my-docs-container.hierarchy .documents-tree .no-documents p {
  font-size: 16px;
  margin: 0 0 20px 0;
}
.my-docs-container.hierarchy .documents-tree .no-documents .add-first-doc-btn {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.my-docs-container.hierarchy .documents-tree .no-documents .add-first-doc-btn:hover {
  background: #0052a3;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-header {
  display: grid;
  grid-template-columns: 1fr 120px 100px 120px;
  gap: 16px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column.name-column {
  text-align: left;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column.date-column, .my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column.size-column {
  text-align: center;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column.actions-column {
  text-align: right;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content {
  display: grid;
  grid-template-columns: 1fr 120px 100px 120px;
  gap: 16px;
  padding: 8px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s;
  align-items: center;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content:hover {
  background-color: #f8f9fa;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content.selected {
  background-color: #e3f2fd;
  border-color: #bbdefb;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content.folder .tree-item-left .item-name {
  font-weight: 600;
  color: #333;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content.file .tree-item-left .item-name {
  font-weight: 500;
  color: #555;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .expand-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  cursor: pointer;
  color: #666;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .expand-icon:hover {
  color: #333;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon {
  flex-shrink: 0;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.folder-icon {
  color: #0066cc;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.pdf-icon {
  color: #dc2626;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.doc-icon {
  color: #2563eb;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.excel-icon {
  color: #10b981;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.image-icon {
  color: #8b5cf6;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-icon.default-icon {
  color: #6b7280;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.folder .file-icon.folder-icon {
  color: #0066cc;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.image {
  border-radius: 4px;
  overflow: hidden;
  background: #f8f9fa;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.image .image-thumbnail {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 4px;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.image .fallback-icon {
  color: #8b5cf6;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.file .file-icon.pdf-icon {
  color: #dc2626;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.file .file-icon.doc-icon {
  color: #2563eb;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.file .file-icon.excel-icon {
  color: #10b981;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .file-preview-container.file .file-icon.default-icon {
  color: #6b7280;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .item-name {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right {
  display: contents;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-date {
  font-size: 13px;
  color: #666;
  text-align: center;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-size {
  font-size: 13px;
  color: #666;
  text-align: center;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  transition: opacity 0.2s;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  background: transparent;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn:hover {
  background: rgba(0, 0, 0, 0.05);
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.download-btn {
  color: #059669;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.download-btn:hover {
  background: #ecfdf5;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.move-btn {
  color: #d97706;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.move-btn:hover {
  background: #fef3c7;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.delete-btn {
  color: #dc2626;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn.delete-btn:hover {
  background: #fee2e2;
}
.my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-children {
  background: rgba(0, 0, 0, 0.01);
}
.my-docs-container .modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.my-docs-container .modal-backdrop .modal {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}
.my-docs-container .modal-backdrop .modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}
.my-docs-container .modal-backdrop .modal .modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.my-docs-container .modal-backdrop .modal .modal-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s;
}
.my-docs-container .modal-backdrop .modal .modal-header .close-btn:hover {
  color: #333;
  background: #f5f5f5;
}
.my-docs-container .modal-backdrop .modal .add-doc-form {
  padding: 20px;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group {
  margin-bottom: 20px;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group input:focus {
  outline: none;
  border-color: #0066cc;
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group input.court-ref-input, .my-docs-container .modal-backdrop .modal .add-doc-form .form-group input.location-input {
  background: #f9f9f9;
  color: #666;
  cursor: not-allowed;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .form-group input.folder-name-input {
  background: white;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.cancel-btn:hover {
  background: #e0e0e0;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.submit-btn {
  background: #0066cc;
  color: white;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.submit-btn:hover:not(:disabled) {
  background: #0052a3;
}
.my-docs-container .modal-backdrop .modal .add-doc-form .modal-actions button.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}
.my-docs-container .modal-backdrop .modal .move-options {
  padding: 20px;
}
.my-docs-container .modal-backdrop .modal .move-options p {
  margin: 0 0 16px 0;
  font-weight: 500;
  color: #333;
}
.my-docs-container .modal-backdrop .modal .move-options .move-option {
  width: 100%;
  padding: 12px 16px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  transition: all 0.2s;
  text-align: left;
}
.my-docs-container .modal-backdrop .modal .move-options .move-option:hover {
  background: #e9ecef;
  border-color: #0066cc;
}
.my-docs-container .modal-backdrop .modal .move-options .modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
.my-docs-container .modal-backdrop .modal .move-options .modal-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.my-docs-container .modal-backdrop .modal .move-options .modal-actions button.cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}
.my-docs-container .modal-backdrop .modal .move-options .modal-actions button.cancel-btn:hover {
  background: #e0e0e0;
}

@media (max-width: 1024px) {
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content {
    grid-template-columns: 1fr 80px 60px 80px;
    gap: 8px;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header .tree-column,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header .item-date,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header .item-size,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-column,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .item-date,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .item-size {
    font-size: 11px;
  }
}
@media (max-width: 768px) {
  .my-docs-container.hierarchy {
    padding: 16px;
  }
  .my-docs-container.hierarchy .my-docs-header .header-top {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
  .my-docs-container.hierarchy .my-docs-header .header-top .header-actions {
    justify-content: stretch;
  }
  .my-docs-container.hierarchy .my-docs-header .header-top .header-actions .add-doc-btn {
    flex: 1 1;
    justify-content: center;
    padding: 10px 16px;
    font-size: 14px;
  }
  .my-docs-container.hierarchy .my-docs-header .info-bar {
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-header {
    display: none;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    padding: 12px 16px;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-left .item-name {
    font-size: 15px;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-date,
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-size {
    font-size: 12px;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions {
    opacity: 1;
  }
  .my-docs-container.hierarchy .documents-tree .tree-container .tree-content .tree-item .tree-item-content .tree-item-right .item-actions .action-btn {
    width: 32px;
    height: 32px;
  }
  .my-docs-container.hierarchy .modal-backdrop .modal {
    width: 95%;
    margin: 20px;
    max-height: 90vh;
  }
  .my-docs-container.hierarchy .modal-backdrop .modal .add-doc-form .modal-actions {
    flex-direction: column;
  }
  .my-docs-container.hierarchy .modal-backdrop .modal .add-doc-form .modal-actions button {
    width: 100%;
  }
}
.loading-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #0066cc;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.file-type-indicator.pdf {
  color: #dc2626;
}
.file-type-indicator.word {
  color: #2563eb;
}
.file-type-indicator.excel {
  color: #10b981;
}
.file-type-indicator.image {
  color: #8b5cf6;
}
.file-type-indicator.folder {
  color: #0066cc;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
  font-size: 13px;
  color: #666;
}
.info-bar .breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
}
.info-bar .breadcrumb .breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}
.info-bar .breadcrumb .breadcrumb-item:hover {
  background: #e9ecef;
  color: #333;
}
.info-bar .breadcrumb .breadcrumb-item.active {
  color: #0066cc;
  font-weight: 500;
  cursor: default;
}
.info-bar .breadcrumb .breadcrumb-item.active:hover {
  background: transparent;
}
.info-bar .breadcrumb > svg {
  color: #999;
  flex-shrink: 0;
}
.info-bar .total-items {
  font-weight: 500;
  white-space: nowrap;
}

.location-input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.location-input-container > svg {
  position: absolute;
  left: 10px;
  color: #666;
  z-index: 1;
}
.location-input-container .location-input {
  padding-left: 32px !important;
  padding-right: 40px !important;
}
.location-input-container .root-btn {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  color: #0066cc;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}
.location-input-container .root-btn:hover {
  background: #f0f8ff;
  color: #0052a3;
}

.upload-section .file-input {
  width: 100%;
  padding: 10px 12px;
  border: 2px dashed #ddd;
  border-radius: 6px;
  background: #fafafa;
  cursor: pointer;
  transition: all 0.2s;
}
.upload-section .file-input:hover {
  border-color: #0066cc;
  background: #f8fbff;
}
.upload-section .file-input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.upload-section .upload-progress {
  margin-top: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}
.upload-section .upload-progress .progress-bar {
  width: 100%;
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
}
.upload-section .upload-progress .progress-bar .progress {
  height: 100%;
  background: linear-gradient(90deg, #0066cc, #4a9eff);
  border-radius: 4px;
  transition: width 0.3s ease;
}
.upload-section .upload-progress span {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}
.upload-section .uploaded-file-preview {
  margin-top: 12px;
  padding: 12px;
  background: #f0f8ff;
  border: 1px solid #cce7ff;
  border-radius: 6px;
}
.upload-section .uploaded-file-preview .file-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.upload-section .uploaded-file-preview .file-info svg {
  color: #0066cc;
  flex-shrink: 0;
}
.upload-section .uploaded-file-preview .file-info span {
  flex: 1 1;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-section .uploaded-file-preview .file-info .cancel-upload-button {
  background: none;
  border: none;
  color: #dc2626;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s;
  line-height: 1;
}
.upload-section .uploaded-file-preview .file-info .cancel-upload-button:hover {
  background: #fee2e2;
}

@media (max-width: 768px) {
  .info-bar {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
  .info-bar .breadcrumb .breadcrumb-item {
    font-size: 12px;
    padding: 3px 6px;
  }
  .info-bar .total-items {
    font-size: 12px;
  }
  .location-input-container .location-input {
    padding-left: 28px !important;
    padding-right: 36px !important;
  }
  .location-input-container > svg {
    left: 8px;
    width: 14px;
    height: 14px;
  }
  .location-input-container .root-btn {
    right: 6px;
    padding: 3px;
  }
  .location-input-container .root-btn svg {
    width: 12px;
    height: 12px;
  }
  .upload-section .file-input {
    padding: 8px 10px;
    font-size: 14px;
  }
  .upload-section .upload-progress {
    padding: 10px;
  }
  .upload-section .upload-progress .progress-bar {
    height: 6px;
  }
  .upload-section .upload-progress span {
    font-size: 11px;
  }
  .upload-section .uploaded-file-preview {
    padding: 10px;
  }
  .upload-section .uploaded-file-preview .file-info {
    gap: 6px;
  }
  .upload-section .uploaded-file-preview .file-info svg {
    width: 14px;
    height: 14px;
  }
  .upload-section .uploaded-file-preview .file-info span {
    font-size: 13px;
  }
  .upload-section .uploaded-file-preview .file-info .cancel-upload-button {
    font-size: 16px;
    padding: 1px 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/RenderMyDocs.scss"],"names":[],"mappings":"AACA;EACI,aAAA;AAAJ;AAGI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AADR;AAOQ;EACI,mBAAA;AALZ;AAQY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AANhB;AASgB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAPpB;AAWgB;EACI,aAAA;EACA,SAAA;AATpB;AAYoB;EACI,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AAVxB;AAawB;EACI,mBAAA;AAX5B;AAewB;EACI,gCAAA;EACA,YAAA;EACA,kCAAA;AAb5B;AAgB4B;EACI,mBAAA;AAdhC;AAsBY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AApBhB;AAuBgB;EACI,gBAAA;AArBpB;AAyBgB;EACI,cAAA;EACA,gBAAA;AAvBpB;AA6BQ;EACI,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA3BZ;AA8BY;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;AA5BhB;AA+BgB;EACI,eAAA;EACA,kBAAA;AA7BpB;AAiCgB;EACI,gCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AA/BpB;AAkCoB;EACI,mBAAA;AAhCxB;AAuCgB;EACI,aAAA;EACA,4CAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AArCpB;AAyCwB;EACI,gBAAA;AAvC5B;AA0CwB;EAEI,kBAAA;AAzC5B;AA6CwB;EACI,iBAAA;AA3C5B;AAmDwB;EACI,aAAA;EACA,4CAAA;EACA,SAAA;EACA,iBAAA;EACA,gCAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;AAjD5B;AAoD4B;EACI,yBAAA;AAlDhC;AAsD4B;EACI,yBAAA;EACA,qBAAA;AApDhC;AAyDgC;EACI,gBAAA;EACA,WAAA;AAvDpC;AA6DgC;EACI,gBAAA;EACA,WAAA;AA3DpC;AAgE4B;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AA9DhC;AAiEgC;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AA/DpC;AAiEoC;EACI,WAAA;AA/DxC;AAoEgC;EACI,cAAA;AAlEpC;AAoEoC;EACI,cAAA;AAlExC;AAqEoC;EACI,cAAA;AAnExC;AAsEoC;EACI,cAAA;AApExC;AAuEoC;EACI,cAAA;AArExC;AAwEoC;EACI,cAAA;AAtExC;AAyEoC;EACI,cAAA;AAvExC;AA4EgC;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA1EpC;AA+E4C;EACI,cAAA;AA7EhD;AAmFoC;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;AAjFxC;AAoFwC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAlF5C;AAsFwC;EACI,cAAA;AApF5C;AA2F4C;EACI,cAAA;AAzFhD;AA4F4C;EACI,cAAA;AA1FhD;AA6F4C;EACI,cAAA;AA3FhD;AA8F4C;EACI,cAAA;AA5FhD;AAmGgC;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAjGpC;AAsG4B;EACI,iBAAA;AApGhC;AAuGgC;EACI,eAAA;EACA,WAAA;EACA,kBAAA;AArGpC;AAyGgC;EACI,eAAA;EACA,WAAA;EACA,kBAAA;AAvGpC;AA2GgC;EACI,aAAA;EACA,yBAAA;EACA,QAAA;EACA,wBAAA;AAzGpC;AA4GoC;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;AA1GxC;AA6GwC;EACI,+BAAA;AA3G5C;AA+GwC;EACI,cAAA;AA7G5C;AA+G4C;EACI,mBAAA;AA7GhD;AAkHwC;EACI,cAAA;AAhH5C;AAkH4C;EACI,mBAAA;AAhHhD;AAqHwC;EACI,cAAA;AAnH5C;AAqH4C;EACI,mBAAA;AAnHhD;AA8HwB;EACI,+BAAA;AA5H5B;AAsII;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AApIR;AAuIQ;EACI,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AArIZ;AAwIY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;AAtIhB;AAyIgB;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAvIpB;AA2IgB;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;AAzIpB;AA6IoB;EACI,WAAA;EACA,mBAAA;AA3IxB;AAiJY;EACI,aAAA;AA/IhB;AAkJgB;EACI,mBAAA;AAhJpB;AAmJoB;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAjJxB;AAqJoB;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,sBAAA;AAnJxB;AAsJwB;EACI,aAAA;EACA,qBAAA;EACA,4CAAA;AApJ5B;AAwJwB;EAEI,mBAAA;EACA,WAAA;EACA,mBAAA;AAvJ5B;AA2JwB;EACI,iBAAA;AAzJ5B;AA+JgB;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AA7JpB;AAgKoB;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AA9JxB;AAiKwB;EACI,mBAAA;EACA,WAAA;EACA,sBAAA;AA/J5B;AAkK4B;EACI,mBAAA;AAhKhC;AAqKwB;EACI,mBAAA;EACA,YAAA;AAnK5B;AAsK4B;EACI,mBAAA;AApKhC;AAwK4B;EACI,gBAAA;EACA,mBAAA;EACA,YAAA;AAtKhC;AA8KY;EACI,aAAA;AA5KhB;AA+KgB;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;AA7KpB;AAiLgB;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AA/KpB;AAkLoB;EACI,mBAAA;EACA,qBAAA;AAhLxB;AAqLgB;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;AAnLpB;AAsLoB;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AApLxB;AAuLwB;EACI,mBAAA;EACA,WAAA;EACA,sBAAA;AArL5B;AAwL4B;EACI,mBAAA;AAtLhC;;AAkMA;EAGY;;IAEI,yCAAA;IACA,QAAA;EAjMd;EAoMc;;;;;;IAGI,eAAA;EA/LlB;AACF;AAsMA;EACI;IACI,aAAA;EApMN;EAwMU;IACI,sBAAA;IACA,SAAA;IACA,oBAAA;EAtMd;EAyMc;IACI,wBAAA;EAvMlB;EA0MkB;IACI,SAAA;IACA,uBAAA;IACA,kBAAA;IACA,eAAA;EAxMtB;EA8MU;IACI,sBAAA;IACA,QAAA;IACA,uBAAA;EA5Md;EAkNU;IACI,aAAA;EAhNd;EAoNU;IACI,aAAA;IACA,sBAAA;IACA,oBAAA;IACA,QAAA;IACA,kBAAA;EAlNd;EAsNkB;IACI,eAAA;EApNtB;EAyNc;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;EAvNlB;EA0NkB;;IAEI,eAAA;EAxNtB;EA4NkB;IACI,UAAA;EA1NtB;EA4NsB;IACI,WAAA;IACA,YAAA;EA1N1B;EAkOM;IACI,UAAA;IACA,YAAA;IACA,gBAAA;EAhOV;EAmOU;IACI,sBAAA;EAjOd;EAmOc;IACI,WAAA;EAjOlB;AACF;AAyOA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AAvOJ;;AA2OA;EACI;IAAK,uBAAA;EAvOP;EAwOE;IAAO,yBAAA;EArOT;AACF;AA0OI;EAAQ,cAAA;AAvOZ;AAwOI;EAAS,cAAA;AArOb;AAsOI;EAAU,cAAA;AAnOd;AAoOI;EAAU,cAAA;AAjOd;AAkOI;EAAW,cAAA;AA/Nf;;AAuOA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AApOJ;AAuOI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AArOR;AAwOQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;AAtOZ;AAyOY;EACI,mBAAA;EACA,WAAA;AAvOhB;AA2OY;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAzOhB;AA4OgB;EACI,uBAAA;AA1OpB;AAiPQ;EACI,WAAA;EACA,cAAA;AA/OZ;AAoPI;EACI,gBAAA;EACA,mBAAA;AAlPR;;AAwPA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AArPJ;AAwPI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAtPR;AA0PI;EACI,6BAAA;EACA,8BAAA;AAxPR;AA4PI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AA1PR;AA6PQ;EACI,mBAAA;EACA,cAAA;AA3PZ;;AAmQI;EACI,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;AAhQR;AAkQQ;EACI,qBAAA;EACA,mBAAA;AAhQZ;AAoQQ;EACI,mBAAA;EACA,YAAA;AAlQZ;AAuQI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AArQR;AAwQQ;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAtQZ;AAyQY;EACI,YAAA;EACA,oDAAA;EACA,kBAAA;EACA,2BAAA;AAvQhB;AA4QQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AA1QZ;AA+QI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA7QR;AAgRQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AA9QZ;AAiRY;EACI,cAAA;EACA,cAAA;AA/QhB;AAmRY;EACI,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjRhB;AAqRY;EACI,gBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;AAnRhB;AAsRgB;EACI,mBAAA;AApRpB;;AA6RA;EACI;IACI,sBAAA;IACA,QAAA;IACA,uBAAA;EA1RN;EA8RU;IACI,eAAA;IACA,gBAAA;EA5Rd;EAiSM;IACI,eAAA;EA/RV;EAqSM;IACI,6BAAA;IACA,8BAAA;EAnSV;EAuSM;IACI,SAAA;IACA,WAAA;IACA,YAAA;EArSV;EAySM;IACI,UAAA;IACA,YAAA;EAvSV;EA0SU;IACI,WAAA;IACA,YAAA;EAxSd;EA+SM;IACI,iBAAA;IACA,eAAA;EA7SV;EAiTM;IACI,aAAA;EA/SV;EAkTU;IACI,WAAA;EAhTd;EAoTU;IACI,eAAA;EAlTd;EAuTM;IACI,aAAA;EArTV;EAwTU;IACI,QAAA;EAtTd;EAyTc;IACI,WAAA;IACA,YAAA;EAvTlB;EA2Tc;IACI,eAAA;EAzTlB;EA6Tc;IACI,eAAA;IACA,gBAAA;EA3TlB;AACF","sourcesContent":["// RenderMyDocs.scss\n.my-docs-container {\n    padding: 20px;\n\n\n    &.loading {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        min-height: 200px;\n        color: #666;\n        font-size: 16px;\n    }\n\n\n    // Hierarchy-specific styles\n    &.hierarchy {\n        .my-docs-header {\n            margin-bottom: 16px;\n\n\n            .header-top {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                margin-bottom: 12px;\n\n\n                h3 {\n                    margin: 0;\n                    font-size: 24px;\n                    font-weight: 600;\n                    color: #333;\n                }\n\n\n                .header-actions {\n                    display: flex;\n                    gap: 12px;\n\n\n                    .add-doc-btn {\n                        background: #f5f5f5;\n                        color: #333;\n                        border: 1px solid #ddd;\n                        padding: 8px 16px;\n                        border-radius: 6px;\n                        cursor: pointer;\n                        font-size: 13px;\n                        font-weight: 500;\n                        display: flex;\n                        align-items: center;\n                        gap: 6px;\n                        transition: all 0.2s;\n\n\n                        &:hover {\n                            background: #e5e5e5;\n                        }\n\n\n                        &.primary {\n                            background: var(--primary-color);\n                            color: white;\n                            border-color: var(--primary-color);\n\n\n                            &:hover {\n                                background: #0052a3;\n                            }\n                        }\n                    }\n                }\n            }\n\n\n            .info-bar {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                padding: 8px 12px;\n                background: #f8f9fa;\n                border-radius: 4px;\n                font-size: 13px;\n                color: #666;\n\n\n                .total-items {\n                    font-weight: 500;\n                }\n\n\n                .selected-info {\n                    color: #0066cc;\n                    font-weight: 500;\n                }\n            }\n        }\n\n\n        .documents-tree {\n            background: white;\n            border: 1px solid #e0e0e0;\n            border-radius: 8px;\n            overflow: hidden;\n\n\n            .no-documents {\n                text-align: center;\n                padding: 60px 20px;\n                color: #666;\n\n\n                p {\n                    font-size: 16px;\n                    margin: 0 0 20px 0;\n                }\n\n\n                .add-first-doc-btn {\n                    background: var(--primary-color);\n                    color: white;\n                    border: none;\n                    padding: 12px 24px;\n                    border-radius: 6px;\n                    cursor: pointer;\n                    font-size: 14px;\n                    font-weight: 500;\n                    transition: background-color 0.2s;\n\n\n                    &:hover {\n                        background: #0052a3;\n                    }\n                }\n            }\n\n\n            .tree-container {\n                .tree-header {\n                    display: grid;\n                    grid-template-columns: 1fr 120px 100px 120px;\n                    gap: 16px;\n                    padding: 12px 16px;\n                    background: #f8f9fa;\n                    border-bottom: 1px solid #e0e0e0;\n                    font-size: 12px;\n                    font-weight: 600;\n                    color: #666;\n                    text-transform: uppercase;\n                    letter-spacing: 0.5px;\n\n\n                    .tree-column {\n                        &.name-column {\n                            text-align: left;\n                        }\n                       \n                        &.date-column,\n                        &.size-column {\n                            text-align: center;\n                        }\n\n\n                        &.actions-column {\n                            text-align: right;\n                        }\n                    }\n                }\n\n\n                .tree-content {\n                    .tree-item {\n                        .tree-item-content {\n                            display: grid;\n                            grid-template-columns: 1fr 120px 100px 120px;\n                            gap: 16px;\n                            padding: 8px 16px;\n                            border-bottom: 1px solid #f0f0f0;\n                            cursor: pointer;\n                            transition: all 0.2s;\n                            align-items: center;\n\n\n                            &:hover {\n                                background-color: #f8f9fa;\n                            }\n\n\n                            &.selected {\n                                background-color: #e3f2fd;\n                                border-color: #bbdefb;\n                            }\n\n\n                            &.folder {\n                                .tree-item-left .item-name {\n                                    font-weight: 600;\n                                    color: #333;\n                                }\n                            }\n\n\n                            &.file {\n                                .tree-item-left .item-name {\n                                    font-weight: 500;\n                                    color: #555;\n                                }\n                            }\n\n\n                            .tree-item-left {\n                                display: flex;\n                                align-items: center;\n                                gap: 8px;\n                                min-width: 0;\n\n\n                                .expand-icon {\n                                    display: flex;\n                                    align-items: center;\n                                    justify-content: center;\n                                    width: 16px;\n                                    height: 16px;\n                                    cursor: pointer;\n                                    color: #666;\n                                   \n                                    &:hover {\n                                        color: #333;\n                                    }\n                                }\n\n\n                                .file-icon {\n                                    flex-shrink: 0;\n                                   \n                                    &.folder-icon {\n                                        color: #0066cc;\n                                    }\n                                   \n                                    &.pdf-icon {\n                                        color: #dc2626;\n                                    }\n                                   \n                                    &.doc-icon {\n                                        color: #2563eb;\n                                    }\n                                   \n                                    &.excel-icon {\n                                        color: #10b981;\n                                    }\n                                   \n                                    &.image-icon {\n                                        color: #8b5cf6;\n                                    }\n                                   \n                                    &.default-icon {\n                                        color: #6b7280;\n                                    }\n                                }\n\n\n                                .file-preview-container {\n                                    flex-shrink: 0;\n                                    width: 24px;\n                                    height: 24px;\n                                    display: flex;\n                                    align-items: center;\n                                    justify-content: center;\n                                    position: relative;\n\n\n                                    &.folder {\n                                        .file-icon {\n                                            &.folder-icon {\n                                                color: #0066cc;\n                                            }\n                                        }\n                                    }\n\n\n                                    &.image {\n                                        border-radius: 4px;\n                                        overflow: hidden;\n                                        background: #f8f9fa;\n\n\n                                        .image-thumbnail {\n                                            width: 24px;\n                                            height: 24px;\n                                            object-fit: cover;\n                                            border-radius: 4px;\n                                        }\n\n\n                                        .fallback-icon {\n                                            color: #8b5cf6;\n                                        }\n                                    }\n\n\n                                    &.file {\n                                        .file-icon {\n                                            &.pdf-icon {\n                                                color: #dc2626;\n                                            }\n                                           \n                                            &.doc-icon {\n                                                color: #2563eb;\n                                            }\n                                           \n                                            &.excel-icon {\n                                                color: #10b981;\n                                            }\n                                           \n                                            &.default-icon {\n                                                color: #6b7280;\n                                            }\n                                        }\n                                    }\n                                }\n\n\n                                .item-name {\n                                    font-size: 14px;\n                                    white-space: nowrap;\n                                    overflow: hidden;\n                                    text-overflow: ellipsis;\n                                }\n                            }\n\n\n                            .tree-item-right {\n                                display: contents;\n\n\n                                .item-date {\n                                    font-size: 13px;\n                                    color: #666;\n                                    text-align: center;\n                                }\n\n\n                                .item-size {\n                                    font-size: 13px;\n                                    color: #666;\n                                    text-align: center;\n                                }\n\n\n                                .item-actions {\n                                    display: flex;\n                                    justify-content: flex-end;\n                                    gap: 4px;\n                                    transition: opacity 0.2s;\n\n\n                                    .action-btn {\n                                        display: flex;\n                                        align-items: center;\n                                        justify-content: center;\n                                        width: 28px;\n                                        height: 28px;\n                                        border: none;\n                                        border-radius: 4px;\n                                        cursor: pointer;\n                                        transition: all 0.2s;\n                                        background: transparent;\n\n\n                                        &:hover {\n                                            background: rgba(0, 0, 0, 0.05);\n                                        }\n\n\n                                        &.download-btn {\n                                            color: #059669;\n                                           \n                                            &:hover {\n                                                background: #ecfdf5;\n                                            }\n                                        }\n\n\n                                        &.move-btn {\n                                            color: #d97706;\n                                           \n                                            &:hover {\n                                                background: #fef3c7;\n                                            }\n                                        }\n\n\n                                        &.delete-btn {\n                                            color: #dc2626;\n                                           \n                                            &:hover {\n                                                background: #fee2e2;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n\n\n                        }\n\n\n                        .tree-children {\n                            background: rgba(0, 0, 0, 0.01);\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n\n    // Modal styles\n    .modal-backdrop {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: rgba(0, 0, 0, 0.5);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        z-index: 1000;\n\n\n        .modal {\n            background: white;\n            border-radius: 8px;\n            width: 90%;\n            max-width: 500px;\n            max-height: 80vh;\n            overflow-y: auto;\n\n\n            .modal-header {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                padding: 20px;\n                border-bottom: 1px solid #e0e0e0;\n\n\n                h3 {\n                    margin: 0;\n                    font-size: 20px;\n                    font-weight: 600;\n                    color: #333;\n                }\n\n\n                .close-btn {\n                    background: none;\n                    border: none;\n                    font-size: 24px;\n                    cursor: pointer;\n                    color: #666;\n                    width: 30px;\n                    height: 30px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    border-radius: 0.25rem;\n                    transition: all 0.2s;\n                    \n\n\n                    &:hover {\n                        color: #333;\n                        background: #f5f5f5;\n                    }\n                }\n            }\n\n\n            .add-doc-form {\n                padding: 20px;\n\n\n                .form-group {\n                    margin-bottom: 20px;\n\n\n                    label {\n                        display: block;\n                        margin-bottom: 8px;\n                        font-weight: 500;\n                        color: #333;\n                        font-size: 14px;\n                    }\n\n\n                    input {\n                        width: 100%;\n                        padding: 10px 12px;\n                        border: 1px solid #ddd;\n                        border-radius: 4px;\n                        font-size: 14px;\n                        transition: border-color 0.2s;\n                        box-sizing: border-box;\n\n\n                        &:focus {\n                            outline: none;\n                            border-color: #0066cc;\n                            box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);\n                        }\n\n\n                        &.court-ref-input,\n                        &.location-input {\n                            background: #f9f9f9;\n                            color: #666;\n                            cursor: not-allowed;\n                        }\n\n\n                        &.folder-name-input {\n                            background: white;\n                        }\n                    }\n                }\n\n\n                .modal-actions {\n                    display: flex;\n                    justify-content: flex-end;\n                    gap: 12px;\n                    margin-top: 24px;\n                    padding-top: 16px;\n                    border-top: 1px solid #e0e0e0;\n\n\n                    button {\n                        padding: 10px 20px;\n                        border: none;\n                        border-radius: 4px;\n                        cursor: pointer;\n                        font-size: 14px;\n                        font-weight: 500;\n                        transition: background-color 0.2s;\n\n\n                        &.cancel-btn {\n                            background: #f5f5f5;\n                            color: #666;\n                            border: 1px solid #ddd;\n\n\n                            &:hover {\n                                background: #e0e0e0;\n                            }\n                        }\n\n\n                        &.submit-btn {\n                            background: #0066cc;\n                            color: white;\n\n\n                            &:hover:not(:disabled) {\n                                background: #0052a3;\n                            }\n\n\n                            &:disabled {\n                                background: #ccc;\n                                cursor: not-allowed;\n                                opacity: 0.7;\n                            }\n                        }\n                    }\n                }\n            }\n\n\n            .move-options {\n                padding: 20px;\n\n\n                p {\n                    margin: 0 0 16px 0;\n                    font-weight: 500;\n                    color: #333;\n                }\n\n\n                .move-option {\n                    width: 100%;\n                    padding: 12px 16px;\n                    background: #f8f9fa;\n                    border: 1px solid #ddd;\n                    border-radius: 4px;\n                    cursor: pointer;\n                    font-size: 14px;\n                    color: #333;\n                    margin-bottom: 8px;\n                    transition: all 0.2s;\n                    text-align: left;\n\n\n                    &:hover {\n                        background: #e9ecef;\n                        border-color: #0066cc;\n                    }\n                }\n\n\n                .modal-actions {\n                    display: flex;\n                    justify-content: flex-end;\n                    gap: 12px;\n                    margin-top: 20px;\n                    padding-top: 16px;\n                    border-top: 1px solid #e0e0e0;\n\n\n                    button {\n                        padding: 10px 20px;\n                        border: none;\n                        border-radius: 4px;\n                        cursor: pointer;\n                        font-size: 14px;\n                        font-weight: 500;\n                        transition: background-color 0.2s;\n\n\n                        &.cancel-btn {\n                            background: #f5f5f5;\n                            color: #666;\n                            border: 1px solid #ddd;\n\n\n                            &:hover {\n                                background: #e0e0e0;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n// Responsive design for hierarchy view\n@media (max-width: 1024px) {\n    .my-docs-container.hierarchy {\n        .documents-tree .tree-container {\n            .tree-header,\n            .tree-content .tree-item .tree-item-content {\n                grid-template-columns: 1fr 80px 60px 80px;\n                gap: 8px;\n\n\n                .tree-column,\n                .item-date,\n                .item-size {\n                    font-size: 11px;\n                }\n            }\n        }\n    }\n}\n\n\n@media (max-width: 768px) {\n    .my-docs-container.hierarchy {\n        padding: 16px;\n\n\n        .my-docs-header {\n            .header-top {\n                flex-direction: column;\n                gap: 12px;\n                align-items: stretch;\n\n\n                .header-actions {\n                    justify-content: stretch;\n\n\n                    .add-doc-btn {\n                        flex: 1;\n                        justify-content: center;\n                        padding: 10px 16px;\n                        font-size: 14px;\n                    }\n                }\n            }\n\n\n            .info-bar {\n                flex-direction: column;\n                gap: 4px;\n                align-items: flex-start;\n            }\n        }\n\n\n        .documents-tree .tree-container {\n            .tree-header {\n                display: none;\n            }\n\n\n            .tree-content .tree-item .tree-item-content {\n                display: flex;\n                flex-direction: column;\n                align-items: stretch;\n                gap: 8px;\n                padding: 12px 16px;\n\n\n                .tree-item-left {\n                    .item-name {\n                        font-size: 15px;\n                    }\n                }\n\n\n                .tree-item-right {\n                    display: flex;\n                    justify-content: space-between;\n                    align-items: center;\n\n\n                    .item-date,\n                    .item-size {\n                        font-size: 12px;\n                    }\n\n\n                    .item-actions {\n                        opacity: 1;\n                       \n                        .action-btn {\n                            width: 32px;\n                            height: 32px;\n                        }\n                    }\n                }\n            }\n        }\n\n\n        .modal-backdrop .modal {\n            width: 95%;\n            margin: 20px;\n            max-height: 90vh;\n\n\n            .add-doc-form .modal-actions {\n                flex-direction: column;\n               \n                button {\n                    width: 100%;\n                }\n            }\n        }\n    }\n}\n\n\n// Loading states\n.loading-spinner {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border: 2px solid #f3f3f3;\n    border-top: 2px solid #0066cc;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n\n// File type indicators\n.file-type-indicator {\n    &.pdf { color: #dc2626; }\n    &.word { color: #2563eb; }\n    &.excel { color: #10b981; }\n    &.image { color: #8b5cf6; }\n    &.folder { color: #0066cc; }\n}\n\n\n// Add these styles to your existing RenderMyDocs.scss file\n\n\n// Breadcrumb navigation styles\n.info-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 12px;\n    background: #f8f9fa;\n    border-radius: 4px;\n    font-size: 13px;\n    color: #666;\n\n\n    .breadcrumb {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n\n\n        .breadcrumb-item {\n            display: flex;\n            align-items: center;\n            gap: 4px;\n            background: none;\n            border: none;\n            color: #666;\n            font-size: 13px;\n            cursor: pointer;\n            padding: 4px 8px;\n            border-radius: 4px;\n            transition: all 0.2s;\n\n\n            &:hover {\n                background: #e9ecef;\n                color: #333;\n            }\n\n\n            &.active {\n                color: #0066cc;\n                font-weight: 500;\n                cursor: default;\n\n\n                &:hover {\n                    background: transparent;\n                }\n            }\n        }\n\n\n        // Chevron separator styling\n        > svg {\n            color: #999;\n            flex-shrink: 0;\n        }\n    }\n\n\n    .total-items {\n        font-weight: 500;\n        white-space: nowrap;\n    }\n}\n\n\n// Location input container with root button\n.location-input-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n\n\n    > svg {\n        position: absolute;\n        left: 10px;\n        color: #666;\n        z-index: 1;\n    }\n\n\n    .location-input {\n        padding-left: 32px !important;\n        padding-right: 40px !important;\n    }\n\n\n    .root-btn {\n        position: absolute;\n        right: 8px;\n        background: none;\n        border: none;\n        color: #0066cc;\n        cursor: pointer;\n        padding: 4px;\n        border-radius: 4px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: all 0.2s;\n\n\n        &:hover {\n            background: #f0f8ff;\n            color: #0052a3;\n        }\n    }\n}\n\n\n// Upload section improvements\n.upload-section {\n    .file-input {\n        width: 100%;\n        padding: 10px 12px;\n        border: 2px dashed #ddd;\n        border-radius: 6px;\n        background: #fafafa;\n        cursor: pointer;\n        transition: all 0.2s;\n       \n        &:hover {\n            border-color: #0066cc;\n            background: #f8fbff;\n        }\n\n\n        &:disabled {\n            cursor: not-allowed;\n            opacity: 0.6;\n        }\n    }\n\n\n    .upload-progress {\n        margin-top: 12px;\n        padding: 12px;\n        background: #f8f9fa;\n        border-radius: 6px;\n        border: 1px solid #e9ecef;\n\n\n        .progress-bar {\n            width: 100%;\n            height: 8px;\n            background: #e9ecef;\n            border-radius: 4px;\n            overflow: hidden;\n            margin-bottom: 8px;\n\n\n            .progress {\n                height: 100%;\n                background: linear-gradient(90deg, #0066cc, #4a9eff);\n                border-radius: 4px;\n                transition: width 0.3s ease;\n            }\n        }\n\n\n        span {\n            font-size: 12px;\n            color: #666;\n            font-weight: 500;\n        }\n    }\n\n\n    .uploaded-file-preview {\n        margin-top: 12px;\n        padding: 12px;\n        background: #f0f8ff;\n        border: 1px solid #cce7ff;\n        border-radius: 6px;\n\n\n        .file-info {\n            display: flex;\n            align-items: center;\n            gap: 8px;\n\n\n            svg {\n                color: #0066cc;\n                flex-shrink: 0;\n            }\n\n\n            span {\n                flex: 1;\n                font-size: 14px;\n                color: #333;\n                font-weight: 500;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n            }\n\n\n            .cancel-upload-button {\n                background: none;\n                border: none;\n                color: #dc2626;\n                font-size: 18px;\n                font-weight: bold;\n                cursor: pointer;\n                padding: 2px 6px;\n                border-radius: 4px;\n                transition: all 0.2s;\n                line-height: 1;\n\n\n                &:hover {\n                    background: #fee2e2;\n                }\n            }\n        }\n    }\n}\n\n\n// Responsive adjustments for breadcrumb\n@media (max-width: 768px) {\n    .info-bar {\n        flex-direction: column;\n        gap: 8px;\n        align-items: flex-start;\n\n\n        .breadcrumb {\n            .breadcrumb-item {\n                font-size: 12px;\n                padding: 3px 6px;\n            }\n        }\n\n\n        .total-items {\n            font-size: 12px;\n        }\n    }\n\n\n    .location-input-container {\n        .location-input {\n            padding-left: 28px !important;\n            padding-right: 36px !important;\n        }\n\n\n        > svg {\n            left: 8px;\n            width: 14px;\n            height: 14px;\n        }\n\n\n        .root-btn {\n            right: 6px;\n            padding: 3px;\n\n\n            svg {\n                width: 12px;\n                height: 12px;\n            }\n        }\n    }\n\n\n    .upload-section {\n        .file-input {\n            padding: 8px 10px;\n            font-size: 14px;\n        }\n\n\n        .upload-progress {\n            padding: 10px;\n\n\n            .progress-bar {\n                height: 6px;\n            }\n\n\n            span {\n                font-size: 11px;\n            }\n        }\n\n\n        .uploaded-file-preview {\n            padding: 10px;\n\n\n            .file-info {\n                gap: 6px;\n\n\n                svg {\n                    width: 14px;\n                    height: 14px;\n                }\n\n\n                span {\n                    font-size: 13px;\n                }\n\n\n                .cancel-upload-button {\n                    font-size: 16px;\n                    padding: 1px 4px;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
